var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$vuetify.breakpoint.width < 1400
      ? 'd-flex flex-wrap'
      : 'd-flex align-center'},[_c('v-chip',{staticClass:"action-name",class:[_vm.labelColor, _vm.$vuetify.breakpoint.width < 1400 ? 'mr-2 mb-1' : ''],attrs:{"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.actionName)+" ")]),(_vm.action.payload && _vm.action.payload.length !== 0)?_c('span',{staticClass:"p-4 grey--text text--darken-4",class:_vm.$vuetify.breakpoint.width < 1400
        ? 'd-flex flex-wrap align-start'
        : 'd-flex align-center ml-2',staticStyle:{"gap":"4px"},domProps:{"innerHTML":_vm._s(_vm.information)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }